import TimeZone from "./TimeZone";
import PropTypes from "prop-types";
import { loginAsAdmin } from "store/actions";
import React, { useState, useRef } from "react";
import AppModal from "component/Modal/AppModal";
import { withTranslation } from "react-i18next";
import { me } from "constants/Client";
import avatar from "assets/images/dummy_image.jpg";
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
import EmpSwtichAcc from "component/TopBar/SwitchAccount/Employee/SwitchAccount";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import SwitchAccount from "component/TopBar/SwitchAccount/OthersRoles/SwitchAccount";
import { IS_STAFF_ROLE, IS_SUPERADMIN_ROLE, IS_WORKSPACE_ADMIN, ROLES, ROLESARR } from "common/ComponentAccess";
import useAccess from "hooks/useAccess";

const ProfileMenu = props => {
  const history = useHistory();
  const swtichAccRef = useRef();
  const dispatch = useDispatch();
  const empSwitchAccRef = useRef();

  const { switchAccount = {} } = useAccess();
  const [menu, setMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const user = me();

  const toggle = () => setModal(!modal);

  const handleAdminLogin = () => {
    dispatch(loginAsAdmin({ client_id: me().uid }, history));
  };

  const onAccountSwitch = () => {
    switch (me()?.role) {
      case ROLES.STAFF:
        empSwitchAccRef.current?.toggle();
        break;
      default:
        swtichAccRef.current?.toggle();
        break;
    }
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className='d-inline-block'>
        <DropdownToggle className='btn header-item' id='page-header-user-dropdown' tag='button'>
          <img className='rounded-circle header-profile-user' src={me()?.pro_pic ? `${process.env.REACT_APP_APIBASE}/${me()?.pro_pic}` : avatar} alt='' />
          <span className='d-none d-xl-inline-block ms-2 me-1'>{user.username}</span>
          <i className='mdi mdi-chevron-down d-none d-xl-inline-block' />
        </DropdownToggle>
        <DropdownMenu className='dropdown-menu-end'>
          {ROLESARR.includes(me()?.role) && (
            <>
              {!IS_SUPERADMIN_ROLE() && (
                <Link to={"/profile"} className='dropdown-item'>
                  <i className='bx bx-user font-size-16 align-middle me-1' />
                  <span>{props.t("User Profile")}</span>
                </Link>
              )}

              {!IS_SUPERADMIN_ROLE() && (
                <Link to={`/employee-profile${!IS_STAFF_ROLE() && me()?.manager_id ? `?id=${me()?.manager_id}` : ""}`} className='dropdown-item'>
                  <i className='bx bx-file font-size-16 me-1' />
                  <span>{props.t("My Documents")}</span>
                </Link>
              )}

              {IS_WORKSPACE_ADMIN() && (
                <Link to='/role-access' className='dropdown-item'>
                  <i className='bx bx-key font-size-16 me-1' />
                  <span>{props.t("Role Access")}</span>
                </Link>
              )}
              {!IS_STAFF_ROLE() && !IS_SUPERADMIN_ROLE() && (
                <Link to='/company-profile' className='dropdown-item'>
                  <i className='bx bx-buildings font-size-16 me-1' />
                  <span>{props.t(`${user.com_name || "Company Profile"}`)}</span>
                </Link>
              )}
              {switchAccount.view && !localStorage.getItem("fastLogin") && (
                <Link to='#' className='dropdown-item' onClick={onAccountSwitch}>
                  <i className='mdi mdi-account-switch-outline font-size-16 me-1' />
                  <span>{props.t("Switch Account")}</span>
                </Link>
              )}
              {!IS_STAFF_ROLE() && !IS_SUPERADMIN_ROLE() && (
                <DropdownItem tag='button' onClick={() => toggle()}>
                  <i className='bx bx-time font-size-16 align-middle me-1' />
                  <span>{props.t("Time Zone")}</span>
                </DropdownItem>
              )}
            </>
          )}
          <div className='dropdown-divider' />
          <Link to='/logout' className='dropdown-item'>
            <i className='bx bx-power-off font-size-16 me-1 text-danger' />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      {localStorage.getItem("fastLogin") && (
        <span role='button' onClick={() => handleAdminLogin()} className='text-danger vh-center'>
          <i className='bx bx-log-out text-normal mx-2 fs-4 text' />
          <strong>Admin</strong>
        </span>
      )}

      <SwitchAccount ref={swtichAccRef} />
      <EmpSwtichAcc ref={empSwitchAccRef} />

      <AppModal isOpen={modal} onToggle={toggle} title='Time Zone'>
        <TimeZone onSuccess={toggle} />
      </AppModal>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(React.memo(ProfileMenu))));
